import { createContext, useContext } from 'react';

const TransitAccountProductCatalogContext = createContext({});

export const useTransitAccountProductCatalogContext = () => useContext(TransitAccountProductCatalogContext);

export default TransitAccountProductCatalogContext;
